import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { WorkflowHookCreateForm } from "./components/WorkflowHookCreateForm";

export function NewWorkflowHookPage() {
  return (
    <Page title="New Hook">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <WorkflowHookCreateForm />
      </Container>
    </Page>
  );
}
